<app-loader *ngIf="isDisabled"></app-loader>
<div class="m-1">
    <div class="row mb-1 m-0" style="column-gap: 5px;">
    <div class="col p-0" *ngFor="let leaveType of LeaveTypes; let i = index">
        <div class="card cardleave">
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <div class="count" style="color: #00d68f">
                            {{ leaveType.LeaveOB }}
                        </div>
                        <div class="label leavename">
                            {{ leaveType.LeaveName }}
                        </div>
                    </div>
                    <div class="col-auto">
                        <div class="icon">
                            <i [class]="iconClass(leaveType.LeaveName)"></i>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
<div class="card">
    <form class="g-3" name="LeaveRequestForm" (ngSubmit)="Validate(LeaveRequestForm)" #LeaveRequestForm="ngForm"
        novalidate>
        <div class="card-body p-0">
            <div class="card mb-1">
                <div class="card-header">
                    Leave Request
                </div>
                <div class="card-body p-3">
                    <div class="row">
                        <div class="col-md">
                            <div class="row mb-3">
                                <div class="col-md-4">
                                    <label for="LeaveTypeID" class="form-font-label">Leave Type<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" aria-label="LeaveTypeID" placeholder="LeaveTypeID"
                                        title="LeaveType" name="LeaveTypeID" data-live-search="true"
                                        [(ngModel)]="LeaveDetail.LeaveTypeID" #LeaveTypeID="ngModel" required>
                                        <option disabled hidden [value]=null>--Select Leave Type--</option>
                                        @for (LeaveType of LeaveTypes; track LeaveType.LeaveMasterID; let i = $index) {
                                        <option [value]="LeaveType.LeaveMasterID">
                                            <div class="row">
                                                <div class="col">{{LeaveType.LeaveName}}</div>
                                                <!-- <div class="col-auto">{{LeaveType.LeaveOB}}</div> -->
                                            </div>
                                        </option>
                                        }
                                    </select>
                                    <div class="invalid-feedback">
                                        Please select leave type!
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label for="FromDate" class="form-font-label"><span class="text-danger">*</span>From
                                        Date</label>
                                    <div class="input-group">
                                        <input class="form-control" placeholder="dd mmm yyyy" name="FromDate"
                                            [(ngModel)]="LeaveDetail.FromDateObj" ngbDatepicker
                                            #FromDate="ngbDatepicker" (ngModelChange)="NoOfDayCount()" required />
                                        <button class="btn btn-outline-secondary bi bi-calendar3"
                                            (click)="FromDate.toggle()" type="button"></button>
                                    </div>
                                    <div class="invalid-feedback">
                                        Please select from date!
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label for="ToDate" class="form-font-label"><span class="text-danger">*</span>To
                                        Date</label>
                                    <div class="input-group">
                                        <input class="form-control" placeholder="dd mmm yyyy" name="ToDate"
                                            [(ngModel)]="LeaveDetail.ToDateObj" ngbDatepicker #ToDate="ngbDatepicker"
                                            (ngModelChange)="NoOfDayCount()" [minDate]="LeaveDetail.FromDateObj"
                                            required />
                                        <button class=" btn btn-outline-secondary bi bi-calendar3"
                                            (click)="ToDate.toggle()" type="button"></button>
                                    </div>
                                    <div class="invalid-feedback">
                                        Please select to date!
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-4 align-self-center">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="HalfDay" name="HalfDay"
                                            [(ngModel)]="LeaveDetail.HalfDay" (change)="NoOfDayCount()">
                                        <label class="form-check-label" for="HalfDay">Half
                                            Day</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label for="HalfDaySession" class="form-font-label">Half Day Session<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" aria-label="HalfDaySession" placeholder="HalfDaySession"
                                        title="HalfDaySession" name="HalfDaySession" data-live-search="true"
                                        [disabled]="!LeaveDetail.HalfDay" [(ngModel)]="LeaveDetail.HalfDaySession"
                                        #HalfDaySession="ngModel" required>
                                        <option disabled hidden [value]=null>--Select Half Day Session--</option>
                                        @for (HalfDaySession of HalfDaySessions; track HalfDaySession.Value; let i =
                                        $index)
                                        {
                                        <option [value]="HalfDaySession.Value">{{HalfDaySession.Name}}</option>
                                        }
                                    </select>
                                    <div class="invalid-feedback">
                                        Please select half day session!
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label for="NoOfDay" class="form-font-label">No Of Day<span
                                            class="text-danger">*</span></label>
                                    <input type="number" class="form-control" placeholder="Ex. 1" id="NoOfDay"
                                        name="NoOfDay" [(ngModel)]="LeaveDetail.NoOfDays" #NoOfDay="ngModel" required
                                        disabled>
                                    <div class="invalid-feedback">
                                        Please enter no of day!
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-6">
                                    <label for="Reason" class="form-font-label">Reason<span
                                            class="text-danger">*</span></label>
                                    <input type="text" class="form-control" placeholder="Ex. Family Function"
                                        id="Reason" name="Reason" [(ngModel)]="LeaveDetail.Reason" #Reason="ngModel"
                                        required>
                                    <div class="invalid-feedback">
                                        Please enter reason!
                                    </div>
                                </div>
                            <!-- </div> -->
                            <!-- <div class="row mb-3"> -->
                                <div class="col-md-6">
                                    <label for="CC" class="form-font-label">CC</label>
                                    <ng-select [items]="CCEmployee" [multiple]="true" bindLabel="FullName"
                                        bindValue="EmpMasterID" placeholder="Select CCEmployee" [closeOnSelect]="false"
                                        [(ngModel)]="LeaveDetail.CC" name="CCEmployee">
                                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox"
                                                [ngModel]="item$.selected" [ngModelOptions]="{ standalone : true }" />
                                            {{item.FullName}}
                                        </ng-template>
                                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                            <div class="ng-value" *ngFor="let item of items.slice(0,3)">
                                                <span class="ng-value-label">{{item.FullName}}</span>
                                            </div>
                                            <div class="ng-value" *ngIf="items.length > 3">
                                                <span class="ng-value-label">{{items.length - 3}} more...</span>
                                            </div>
                                        </ng-template>
                                    </ng-select>
                                    <div class="invalid-feedback">
                                        Please select cc!
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-10">
                                    <label for="formFile" class="form-font-label"><i
                                            class="bi bi-paperclip me-1"></i>Attachment
                                        <!-- <span class="text-danger">*</span> -->
                                    </label>
                                    <input class="form-control" type="file" id="formFile"
                                        (change)="upload($event,'EmployeeLeaveAttachment')"
                                        accept=".pdf,.jpg,.jpeg,.png">
                                    <div class="invalid-feedback">
                                        Please upload attachment!
                                    </div>
                                </div>
                                <div class="col-md-2 mt-4" *ngIf="LeaveDetail.LeaveAttachmenturl">
                                    <a [href]="!isDisabled?LeaveDetail.LeaveAttachmenturl:''" target="_blank"
                                        role="button" class="btn btn-outline-primary"><i class="bi bi-paperclip me-2"
                                            *ngIf="!isDisabled"></i><span class="spinner-border spinner-border-sm"
                                            role="status" aria-hidden="true" *ngIf="isDisabled"></span>
                                        {{!isDisabled?'View':'Loading...'}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                        <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                            (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Cancel':'Loading...'}}</button>
                            
                        <button type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                                *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Save':'Loading...'}}</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
</div>
